import { CreateTicketDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { useTeams } from 'modules/ticketing/hooks/useTeams'
import app from 'modules/core/store/models/app'

export const useCreateTicket: OneCreationActionResolver = () => {
  const { company } = useCurrentSession()
  const { teams } = useTeams()
  const [createTicket, { loading }] = useMutation(CreateTicketDocument, {
    extractorFn: (data) => data.ticketingMutations.createTicketingTicket,
    errorPolicy: 'all',
  })

  const createTicketHandler = async (
    args: { title: string; description: string },
    _threadId: string
  ) => {
    const { title, description } = args

    const defaultTeamId = teams[0]?.value
    if (!defaultTeamId) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ticketing.inbox.create.no_teams_available'),
      })
      return undefined
    }

    const result = await createTicket({
      variables: {
        companyId: company.id,
        title,
        description,
        assigneeTeamId: defaultTeamId,
      },
    })

    return handleResult(result, (_errors) => {})
  }

  return {
    resolver: createTicketHandler,
    loading,
  }
}
